import { render, staticRenderFns } from "./MainCategoriesCard.vue?vue&type=template&id=97d8692e&"
import script from "./MainCategoriesCard.vue?vue&type=script&lang=js&"
export * from "./MainCategoriesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports